import React, { useLayoutEffect } from 'react';
import { bool, func, number } from 'prop-types';
import { connect } from 'react-redux';
import PageMessageService from 'mangools-commons/dist/services/PageMessageService';

import AnnouncementMessage from 'components/messages/topLevel/AnnouncementMessage';
import NewUserMessage from 'components/messages/topLevel/NewUserMessage';

import { requestedNavigationAction } from 'actions/routerActions';
import { closeTopLevelAnnouncementMessage } from 'actions/uiActions';

import { announcementMesageVisibilitySelector, announcementsMessageDataSelector } from 'selectors/dataSelectors';
import {
    campaignBannerSelector,
    newUserDiscountActiveSelector,
    newUserDiscountTimerLimitSelector,
} from 'selectors/userSelectors';
import { isReportRouteSelector } from 'selectors/commonSelectors';

import RoutePaths from 'constants/RoutePaths';

import AnnouncementType from 'types/AnnouncementType';
import CampaignBannerType from 'types/CampaignBannerType';
import { IS_CUSTOM_DOMAIN } from 'constants/isCustomDomain';

/**
 * Top Level messages and notifications wrapper.
 * Can be used for cookie info, notifications, etc.
 */
function TopLevelMessageContainer(props) {
    useLayoutEffect(() => PageMessageService.trackHeight());

    if (props.isReportRoute) {
        return null;
    } else {
        return (
            <>
                <AnnouncementMessage
                    btnText={props.announcementMesageData.btnText}
                    icon={props.announcementMesageData.icon}
                    messageText={props.announcementMesageData.messageText}
                    newTab={props.announcementMesageData.newTab}
                    onClose={props.onCloseAnnouncementMessage}
                    url={props.announcementMesageData.url}
                    visible={props.announcementMesageVisible}
                />
                {!IS_CUSTOM_DOMAIN && (
                    <NewUserMessage
                        campaignBanner={props.campaignBanner}
                        visible={props.newUserVisible}
                        timerLimitSeconds={props.timerLimitSeconds}
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = state => ({
    announcementMesageData: announcementsMessageDataSelector(state),
    announcementMesageVisible: announcementMesageVisibilitySelector(state),
    campaignBanner: campaignBannerSelector(state),
    newUserVisible: newUserDiscountActiveSelector(state),
    timerLimitSeconds: newUserDiscountTimerLimitSelector(state),
    isReportRoute: isReportRouteSelector(state),
});

const mapDispatchToProps = dispatch => ({
    onCloseAnnouncementMessage() {
        dispatch(closeTopLevelAnnouncementMessage());
    },
    requestedNavigationToNewTracking() {
        dispatch(requestedNavigationAction(RoutePaths.NEW, {}));
    },
    requestedNavigationToTrackings() {
        dispatch(requestedNavigationAction(RoutePaths.TRACKINGS, {}));
    },
});

TopLevelMessageContainer.propTypes = {
    announcementMesageData: AnnouncementType.isRequired,
    announcementMesageVisible: bool.isRequired,
    campaignBanner: CampaignBannerType,
    newUserVisible: bool.isRequired,
    onCloseAnnouncementMessage: func.isRequired,
    timerLimitSeconds: number.isRequired,
    isReportRoute: bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(TopLevelMessageContainer);
